export default [
  {
    name: 'Product Calls List',
    path: '/product-calls/list',
    component: () => import('@/modules/productCalls/pages/ProductCalls'),
    meta: {
      ability: [
        {
          resource: 'product-calls',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'View Product Call',
    path: '/product-calls/view/:id',
    component: () => import('@/modules/productCalls/pages/ProductCallDetails'),
    meta: {
      ability: [
        {
          resource: 'product-calls/:id',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Product Calls Report',
    path: '/product-calls/report',
    component: () => import('./pages/ProductCallsDateReport'),
    meta: {
      ability: [
        {
          resource: 'product-calls-report/date-report/:type',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Product Grouped Calls Report',
    path: '/product-calls/grouped-report',
    component: () => import('./pages/ProductCallsGroupedReport.vue'),
    meta: {
      ability: [
        {
          resource: 'product-calls-report/grouped/:type',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Product Calls Realtime Report',
    path: '/product-calls/realtime-report',
    component: () => import('../reports/realtime/pages/Realtime.vue'),
    props:{
      api: 'product-calls/group-date-product-report',
    },
    meta: {
      ability: [
        {
          resource: 'product-calls/group-date-product-report',
          actions: ['read'],
        },
      ],
    },
  },
]
